<template>

    <v-dropdown
        icon="far fa-globe"
        theme="trans"
        :selected="$store.getters.lang ?? 'en'"
        :items="items"
        :show-selected="false"
        :menu-position="'br'"
        :aria-label="$t('labels.language')"
        @change="selectLanguage"
    />

</template>

<script>

import { languages } from '@/config';

export default {

    data() {
        return {
            items: Object.entries(languages).map(([key, value]) => ({ key, value })),
        }
    },

    methods: {

        selectLanguage(item) {
            this.$store.commit('setLang', item.key);
            window.location.reload();
        },

    },

}

</script>
